import type { ArrayOfStores, PartialFunctionIntersection } from './types';

export const getDataFromStores = <K, U extends ArrayOfStores<K>>(
    ...stores: U
): PartialFunctionIntersection<U[number]['getData']> => {
    const storesData = stores.map((store) => store.getData());

    return Object.assign({}, ...storesData);
};
